import React from 'react';
import { Route } from 'react-router';
import { Redirect, Switch, useParams } from 'react-router-dom';
import { userHasInventoryEnabledRedir } from '../core/auth';
import { useFeatureFlag } from '../core/hooks/useFeatureFlag';
import InventoryDetailPage from '../views/inventory/containers/InventoryDetailPage';
import Inventory from '../views/inventory/containers/Inventory';
import InventoryTypeTable from '../views/inventory/components/InventoryTypeTable';
import InventoryTabs from '../views/inventory/containers/InventoryTabs';
import AssetsContainer from '../views/assets/containers/AssetsContainer';

const InventoryRoute = () => {
  const { site } = useParams();
  const myAssetsEnabled = useFeatureFlag('my-assets', true);

  return (
    <div className="container-fluid">
      <div className="page-main-content">
        <Switch>
          <Route exact path="/:site/inventory">
            <Inventory />
          </Route>
          <Route path="/:site/inventory/types">
            <InventoryTypeTable />
          </Route>
          <Route path="/:site/inventory/my-assets">
            {myAssetsEnabled ? <AssetsContainer /> : <Redirect to={`/${site}/inventory`} />}
          </Route>
          <Route path="/:site/inventory/:inventory">
            <InventoryDetailPage />
          </Route>
        </Switch>
      </div>
    </div>
  );
};

export default userHasInventoryEnabledRedir(InventoryRoute);
